import React, { Component } from 'react';
import { emailRegExp } from '../../helpers';
import { withRouter } from 'react-router-dom';
import { API_BASE, CONTACTS_DB_URL } from '../../utils/constants';
import FormView from '../../components/FormView';
import withCoffeeService from '../../hoc/withCoffeeService';

class Form extends Component {
  state = {
    name: '',
    email: '',
    phone: '',
    orderMessage: '',
    notValidWarnings: {
      nameNotValid: 'Name must contains 2-20 characters',
      emailNotValid: 'Please provide a valid email address',
      orderMessageNotValid: 'Please fill this field to send the form',
    },
    deniedSubmitFields: {
      validEmail: true,
      validOrderMessage: true,
      validName: true,
      deniedSubmissionsCounter: 0,
    },
    isFetchingFields: {
      loading: false,
    }
  }

  onValueChange = ({ target: { value, name } }) => {
    const { deniedSubmitFields } = this.state

    for (let key in deniedSubmitFields) {
      if (key.toLowerCase().includes(name.toLowerCase())) {
        this.setState({ deniedSubmitFields: { ...deniedSubmitFields, [key]: true } })
      }
    }

    this.setState({
      [name]: value,
    })
  }

  onEmailValidation = () => {
    const { email } = this.state

    if (!emailRegExp.test(email)) {
      return false
    }
    return true
  }

  onNameValidation = () => {
    const { name } = this.state

    if (name.length < 2 || name.length > 20) {
      return false
    }
    return true
  }

  onOrderMessageValidation = () => {
    const { orderMessage } = this.state

    if (!orderMessage) {
      return false
    }
    return true
  }

  onStateDataFilter = () => {
    const filteredState = Object.entries(this.state)
      .map(item => item.filter(el => !(el instanceof Object)))
      .filter(item => item.length > 1)

    const postDataObj = {}

    filteredState.forEach(el => postDataObj[el[0]] = el[1])

    return postDataObj
  }

  onLoading = () => {
    this.setState(({ isFetchingFields: { loading: true } }))
  }

  onLoaded = () => {
    this.setState(({ isFetchingFields: { loading: false } }))
  }

  submitHandler = (event) => {
    event.preventDefault()
    const { history, coffeeService } = this.props

    if (this.onEmailValidation() && this.onNameValidation() && this.onOrderMessageValidation()) {
      event.preventDefault()

      coffeeService.formSubmit(`${API_BASE}${CONTACTS_DB_URL}`, this.onStateDataFilter())
        .then(this.onLoading())
        .then(() => {
          this.onLoaded()
          history.push("/thank-you")
        })
        .catch(() => {
          this.onLoaded()
          history.push("/error-page")
        })
    }

    this.setState(({ deniedSubmitFields: { deniedSubmissionsCounter } }) => {
      return {
        deniedSubmitFields: {
          deniedSubmissionsCounter: ++deniedSubmissionsCounter,
          validEmail: this.onEmailValidation(),
          validName: this.onNameValidation(),
          validOrderMessage: this.onOrderMessageValidation()
        }
      }
    })
  }

  render() {
    const {
      name, phone,
      notValidWarnings: { nameNotValid, emailNotValid, orderMessageNotValid },
      deniedSubmitFields: { validEmail, validOrderMessage, validName, deniedSubmissionsCounter },
      isFetchingFields: { loading },
    } = this.state

    return (
      <FormView
        name={name}
        phone={phone}
        nameNotValid={nameNotValid}
        emailNotValid={emailNotValid}
        orderMessageNotValid={orderMessageNotValid}
        validEmail={validEmail}
        validOrderMessage={validOrderMessage}
        validName={validName}
        deniedSubmissionsCounter={deniedSubmissionsCounter}
        onValueChange={e => this.onValueChange(e)}
        submitHandler={e => this.submitHandler(e)}
        loading={loading}
      />
    )
  }
}

export default withCoffeeService()(withRouter(Form))
